import { render, staticRenderFns } from "./IconProfile.vue?vue&type=template&id=7cf93ee1"
import script from "./IconProfile.vue?vue&type=script&lang=js"
export * from "./IconProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports